// NOTE(memben): keep file in sync with platform.botbrains.io
import React from "react";
import useUtmify from "../utm";

interface SlideProbs {
  image?: string;
  title?: string;
  subtitle?: string;
  link?: string;
  price?: string;
}

export function Slide({ ...props }: SlideProbs) {
  const image = props.image;
  const title = props.title;
  const subtitle = props.subtitle;
  const link = props.link;
  const price = props.price;

  const utmify = useUtmify();

  let processedLink = link;
  try {
    if (link && link.startsWith("http")) {
      processedLink = utmify(link, "carousel_link");
    }
  } catch (error) {
    console.warn("Failed to utmify carousel link:", error);
  }

  const cardContent = (
    <div className="bg-white box-content rounded-2xl shadow-sm hover:shadow border border-gray-200 transition-shadow duration-200 w-56 flex flex-col overflow-hidden h-full">
      {image && (
        <div className="w-full h-56  flex items-center justify-center overflow-hidden relative">
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover blur-sm opacity-60"
          />
          <img
            src={image}
            alt={title || "Card image"}
            className="max-w-full max-h-full object-contain relative z-10"
          />
        </div>
      )}
      <div className="py-2 px-3 flex flex-col flex-1 flex-shrink-0 justify-between h-full">
        <div>
          {title && (
            <h3 className="text-base font-semibold text-gray-900 line-clamp-2 leading-tight m-0 min-h-[2.5em]">
              {title}
            </h3>
          )}
          {price && (
            <h3 className="text-base font-semibold line-clamp-1 leading-tight mt-2 text-brand min-h-[1.5em]">
              {price}
            </h3>
          )}
        </div>
        {subtitle && (
          <p className="text-sm mt-2 text-gray-600 line-clamp-3 min-h-[3.5em]">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );

  if (processedLink) {
    return (
      <a
        href={processedLink}
        target="_blank"
        rel="noreferrer"
        className="block no-underline"
      >
        {cardContent}
      </a>
    );
  }

  return cardContent;
}

interface CarouselProps {
  children?: React.ReactNode;
}

export function Carousel({ children }: CarouselProps) {
  return (
    <div className="w-full overflow-x-auto pb-1 no-scrollbar">
      <div className="flex gap-4 items-stretch">{children}</div>
    </div>
  );
}
